import React from "react";

/**
 * SVG icon glyphs per Pulse Feed events. Puri stroke (Lucide-like).
 * Ogni icona ~14px, va renderizzata dentro un cerchio 32px background #F1F5F9.
 */
export function EventIcon({ type, size = 14, stroke = "#334155" }) {
    const common = {
        width: size, height: size, viewBox: "0 0 24 24",
        fill: "none", stroke, strokeWidth: 1.8,
        strokeLinecap: "round", strokeLinejoin: "round",
    };
    switch (type) {
        case "ticket_created":
        case "ticket_updated":
        case "ticket_message_sent":
            return (
                <svg {...common}>
                    <path d="M2 9V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 0 0-4Z" />
                    <path d="M13 6v2M13 12v2M13 18v2" />
                </svg>
            );
        case "document_uploaded":
            return (
                <svg {...common}>
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
                    <path d="M14 2v6h6" />
                    <path d="M12 18v-6M9 15l3-3 3 3" />
                </svg>
            );
        case "note_created":
            return (
                <svg {...common}>
                    <path d="M12 20h9" />
                    <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4Z" />
                </svg>
            );
        case "user_invited":
            return (
                <svg {...common}>
                    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="8.5" cy="7" r="4" />
                    <path d="M20 8v6M23 11h-6" />
                </svg>
            );
        case "meeting_scheduled":
            return (
                <svg {...common}>
                    <rect x="3" y="4" width="18" height="18" rx="2" />
                    <path d="M16 2v4M8 2v4M3 10h18" />
                </svg>
            );
        case "dm_message_sent":
            return (
                <svg {...common}>
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z" />
                </svg>
            );
        default:
            return (
                <svg {...common}>
                    <circle cx="12" cy="12" r="4" />
                </svg>
            );
    }
}

/**
 * Trasforma un event doc dal Pulse in fragmenti frase italiani.
 * Restituisce { icon, verb, objectText, hasCompany }
 */
export function describeEvent(ev) {
    const p = ev.payload || {};
    switch (ev.event_type) {
        case "ticket_created":
            return { verb: "ha aperto il ticket",
                objectText: p.title ? `«${p.title}»` : "" };
        case "ticket_updated":
            return { verb: "ha aggiornato lo stato del ticket",
                objectText: p.title
                    ? `«${p.title}»${p.new_status ? ` → ${_ticketStatusLabel(p.new_status)}` : ""}`
                    : "" };
        case "ticket_message_sent":
            return { verb: "ha risposto al ticket",
                objectText: p.title ? `«${p.title}»` : "" };
        case "document_uploaded":
            return { verb: "ha caricato il documento",
                objectText: p.document_name ? `«${p.document_name}»` : "" };
        case "note_created":
            return { verb: p.shared ? "ha condiviso una nota" : "ha scritto una nota interna",
                objectText: "" };
        case "user_invited":
            return { verb: "ha invitato",
                objectText: p.invitee_name ? p.invitee_name : "un nuovo utente" };
        case "meeting_scheduled":
            return { verb: "ha programmato la riunione",
                objectText: p.title ? `«${p.title}»` : "" };
        case "dm_message_sent":
            return { verb: "ha inviato un messaggio",
                objectText: "" };
        default:
            return { verb: "ha registrato un'attività", objectText: "" };
    }
}

function _ticketStatusLabel(status) {
    const M = { aperto: "aperto", in_lavorazione: "in lavorazione",
                in_attesa: "in attesa", chiuso: "chiuso" };
    return M[status] || status;
}
